import corporateClientAppModel from "./corporate_client_app.model";
import { CrudModel } from "./_crud";
import { crudGet, crudRead } from "./_request";

export class GoalsModel extends CrudModel {
	constructor() {
		super("app/goals");
	}

	async getGoalsInformations(id: string, cpf: string, accessCode: string) {
		return this.post(id, "info", { cpf, accessCode });
	}
}

export default new GoalsModel();
